import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { TableContainer, Table, TableBody, TableCell, TableRow, Tooltip } from '@mui/material';
import { BoldTableHead, DenseTableCell } from 'components/common/CommonStyles';

const WebExposureComponent = ({ t, exposure, currencyValue }) => {
  return (
    <TableContainer>
      <Table>
        <BoldTableHead>
          <TableRow>
            <DenseTableCell title={t('Document.Exposure.PartnerName')}>{t('Document.Exposure.PartnerName')}</DenseTableCell>
            <DenseTableCell title={t('Document.Exposure.PartnerRole')}>{t('Document.Exposure.PartnerRole')}</DenseTableCell>
            <DenseTableCell title={t('Document.Exposure.DocumentType')}>{t('Document.Exposure.DocumentType')}</DenseTableCell>
            <DenseTableCell title={t('Document.Exposure.DocumentNumber')}>{t('Document.Exposure.DocumentNumber')}</DenseTableCell>
            <DenseTableCell title={t('Document.Exposure.DocumentDate')}>{t('Document.Exposure.DocumentDate')}</DenseTableCell>
            <DenseTableCell title={t('Document.Exposure.TotalAmount')}>{t('Document.Exposure.TotalAmount')}</DenseTableCell>
            <DenseTableCell title={t('Document.Exposure.FinancedAmount')}>{t('Document.Exposure.FinancedAmount')}</DenseTableCell>
            <DenseTableCell title={t('Document.Exposure.Exposure')}>{t('Document.Exposure.Exposure')}</DenseTableCell>
            <DenseTableCell title={t('Document.Exposure.ContractType')}>{t('Document.Exposure.ContractType')}</DenseTableCell>
            <DenseTableCell title={t('Document.Exposure.AssetType')}>{t('Document.Exposure.AssetType')}</DenseTableCell>
            <Tooltip title={t('Tooltips.ExposureInstallments')}>
              <DenseTableCell title={t('Document.Exposure.Installments')}>{t('Document.Exposure.Installments')}</DenseTableCell>
            </Tooltip>
            <DenseTableCell title={t('Document.Exposure.ContractWarranties')}>{t('Document.Exposure.ContractWarranties')}</DenseTableCell>
            <DenseTableCell title={t('Document.Exposure.NetRiskExposure')}>{t('Document.Exposure.NetRiskExposure')}</DenseTableCell>
          </TableRow>
        </BoldTableHead>
        <TableBody>
          {exposure.map(x => {
            return (
              <TableRow key={x.id}>
                <TableCell align='center'>{x.partnerName}</TableCell>
                <TableCell align='center'>{x.partnerRole}</TableCell>
                <TableCell align='center'>{x.documentType}</TableCell>
                <TableCell align='center'>{x.documentNumber}</TableCell>
                <TableCell align='center'>{t('DATE', { date: x.documentDate })}</TableCell>
                <TableCell align='center'>{t('DECIMAL', { number: x.totalAmount * currencyValue })}</TableCell>
                <TableCell align='center'>{t('DECIMAL', { number: x.financedAmount * currencyValue })}</TableCell>
                <TableCell align='center'>{t('DECIMAL', { number: x.exposure * currencyValue })}</TableCell>
                <TableCell align='center'>{x.contractType}</TableCell>
                <TableCell align='center'>{x.assetType}</TableCell>
                <TableCell align='center'>
                  {x.monthNo}/{x.monthNo - x.invoicedRates}/{x.invoicedRates}
                </TableCell>
                <TableCell align='center'>{x.contractWarranties}</TableCell>
                <TableCell align='center'>{t('DECIMAL', { number: x.netExposure * currencyValue })}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

WebExposureComponent.propTypes = {
  t: PropTypes.func.isRequired,
  exposure: PropTypes.array.isRequired,
  currencyValue: PropTypes.number.isRequired
};

export default withTranslation()(WebExposureComponent);
